export default function Header() {
  return (
    <header className="header">
      <h1>Typing Speed Test</h1>
      <p>How fast can you type?</p>
    </header>
  )
}
